import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { QRCodeSVG } from "qrcode.react";
import { Printer } from "@phosphor-icons/react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function SessionPosterPage() {
  const { id } = useParams();
  const [info, setInfo] = useState(null);
  const [err, setErr] = useState(false);

  useEffect(() => {
    document.title = "Session poster — The Self-Agency Project";
    fetch(`${API}/site/session/${id}`)
      .then((r) => { if (!r.ok) throw new Error(); return r.json(); })
      .then(setInfo).catch(() => setErr(true));
  }, [id]);

  if (err) return <div className="min-h-screen bg-white grid place-items-center text-[#52525B]">Session not found.</div>;
  if (!info) return <div className="min-h-screen bg-white" />;

  const virtual = info.session_type === "virtual";
  let nice = info.date;
  try {
    nice = new Date(`${info.date}T${info.time}:00`).toLocaleDateString("en-CA", { weekday: "long", month: "long", day: "numeric" });
  } catch { /* keep iso */ }
  const url = `${window.location.origin}/session/${id}`;

  return (
    <div className="min-h-screen bg-white text-black" data-testid="session-poster-page">
      <div className="max-w-xl mx-auto px-8 py-10 text-center">
        <button onClick={() => window.print()} data-testid="poster-print-btn"
          className="print:hidden mb-8 inline-flex items-center gap-2 bg-black text-white font-bold text-sm px-5 py-2.5 rounded-full border-0 cursor-pointer">
          <Printer size={16} weight="bold" /> Print this poster
        </button>
        <div className="text-xs font-bold uppercase tracking-[0.2em] text-[#52525B]">The Self-Agency Project</div>
        <h1 className="text-5xl font-extrabold font-display mt-3 mb-2 leading-tight">Self-Agency<br />Session</h1>
        <div className="text-2xl font-bold font-display mt-4" data-testid="poster-when">{nice}</div>
        <div className="text-xl font-semibold">{info.time12} <span className="text-[#71717A] text-base">({info.timezone.replace("America/", "")} time)</span></div>
        {!virtual && info.location && <div className="text-base text-[#3F3F46] mt-1" data-testid="poster-where">{info.location}</div>}
        {virtual && <div className="text-base text-[#3F3F46] mt-1">Online session — scan for the link</div>}
        <div className="inline-block border-4 border-black rounded-2xl p-5 mt-8" data-testid="poster-qr">
          <QRCodeSVG value={url} size={240} />
        </div>
        <div className="text-lg font-bold font-display mt-4">Scan for details &amp; tap "I'm coming"</div>
        <div className="text-sm text-[#52525B] mt-1">Time, place, what to wear, what to bring — all on your phone.</div>
        {info.what_to_wear && (
          <div className="text-sm text-[#3F3F46] mt-6 border-t border-[#E4E4E7] pt-4">
            <b>Wear:</b> {info.what_to_wear}
          </div>
        )}
        <div className="text-xs text-[#A1A1AA] mt-6">selfagency.ca · brought to you by Elevation650</div>
      </div>
    </div>
  );
}
